<template>
  <div class="col-span-12">
    <div class="grid grid-cols-12 gap-4">
      <div class="col-span-8 mt-2 mx-auto">
        <div class="mx-auto">
          <span class="lds-ring" v-if="loading">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </span>
        </div>
        <div class="grid grid-cols-12 gap-4">
          <div class="col-span-12">
            <EDMSLegalDocument class="w-full border border-gray" :file="store.edms_file" />
          </div>
          <div class="col-span-12" v-if="noDocs">
            <div class="bg-green-50 border border-green-300 rounded px-4 py-3 text-green-700">
              <p>
                <b>Notice:</b>
                <span>Document is still migrating to EDMS. Give it another 15 mins to be available for viewing</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref, watch } from "vue";
import { useLegalDocumentsRegistryStore } from "@/stores/legal-documents-registry";
import EDMSLegalDocument from "@/domains/home/services/registry/legal-documents/document/EDMSLegalDocument.vue";

const props = defineProps({
  documentHandle: String
});

const store = useLegalDocumentsRegistryStore();

const loading = ref(false);
const noDocs = ref(false);

onMounted(() => {
  view();
});

const view = () => {
  if (props.documentHandle) {
    let data = {
      documentHandle: props.documentHandle,
      overlay: ""
    };
    loading.value = true;
    store.fetchLegalDocumentEDMSFile(data);
  } else {
    noDocs.value = true;
  }
}

watch(() => store.edms_file, () => {
  loading.value = false;
});
</script>
